import os from 'os'
const pty = require('node-pty')
import * as tu from './terminal-utils'
import colors from 'chalk'
import fs from 'fs-extra'
import path from 'path'

export default class Installer {
    constructor (installData, callback) {
        this.installData = installData
        this.name = this.installData.dep.split('@')[0]
        this.version = this.installData.dep.split('@')[1]
        if (!this.version.match(/^[\^\~\*]/)) {
            this.version = '^' + this.version
        }
        
        return new Promise((resolve, reject) => {
            const shell = os.platform() === 'win32' ? 'powershell.exe' : 'bash';
            const ptyProcess = pty.spawn(shell, [], {
                name: 'xterm-color',
                TERM: 'xterm-256color',
                COLORTERM: 'truecolor',
                cols: 80,
                rows: 30,
                cwd: installData.cwd,
                env: process.env,
                stdio: ['inherit', 'inherit', 'inherit', 'ipc']
            })
            
            this.updateLine(true, null, 'Preparing...')
            ptyProcess.on('data', data => {
                
                if (this.exited) {
                    return
                }

                data = data.toString()

                if (
                    !data ||
                    data.startsWith('npm install ') ||
                    data == '\n' || data == '\r'
                ) {
                    return
                }

                if (!this.hasErrors && (data.startsWith('npm ERR!') || data.startsWith('ERR'))) {
                    this.hasErrors = true
                    console.log(`\n${colors.bgRed(this.installData.dep)} > ${data}`)
                    return
                }

                // the progress bar looks like this: ⸨  ░░░░░░░░░░░░░░░░⸩
                if (data.startsWith('⸨')) {
                    let progress = data.match(/(⸨[^⸩]+⸩)(.+)/)
                    if (progress) {
                        this.updateLine(
                            false,
                            colors.greenBright(progress[1].slice(1, -1)) +
                            progress[2].substring(0, 2),
                            progress[2].substring(3)
                        )
                    }
                } else {
                    if (this.hasErrors) {
                        process.stdout.write(data)
                    }
                }
            })

            const commands = [
                // installs the dependency in the separate path
                `npm install ${installData.dep} ` +
                    `--prefix ./.tmp-installing-files/${this.name}` +
                    ` | grep '⸨'`
            ]
            ptyProcess.write(`${commands.join(' && ')}; exit\r`)

            // ptyProcess.on('error', data => {
            //     console.log('ERRRRROR', arguments)
            // })

            const instalationNodeModules = path.resolve(installData.cwd, 'node_modules/')
            const tmpInstalationPath = path.resolve(installData.cwd, '.tmp-installing-files/')

            ptyProcess.on('exit', _ => {
                this.exited = true
                try {
                    ptyProcess.kill()
                } catch (error) {}
                if (this.hasErrors) {
                    // failed
                    this.updateLine(
                        false,
                        colors.bgRedred(''.padStart(18, ' ')),
                        'Installation failed!')
                    reject(this)
                } else {

                    this.updateLine(
                        false,
                        colors.greenBright(''.padStart(18, '█')),
                        'Moving and updating dependencies...')

                    // read the lock-file
                    fs.readFile(path.resolve(
                        tmpInstalationPath,
                        this.name,
                        'package-lock.json'
                    )).then(async content => {
                        let dependencies = JSON.parse(content).dependencies
                        
                        // move each installed dependency into the further's node_module
                        for (let dep in dependencies) {
                            // dep = dependencies[dep]
                            try {
                                await fs.move(
                                    // from
                                    path.resolve(
                                        tmpInstalationPath,
                                        this.name,
                                        'node_modules',
                                        dep
                                    ),
                                    // to
                                    path.resolve(
                                        instalationNodeModules,
                                        dep
                                        // 'node_modules'
                                    ), {
                                        overwrite: false
                                    })
                            } catch (err) {
                                // tu.errorMessage('Failed moving dependencies for ' + dep, err)
                                reject('Failed moving dependencies for ' + this.name + '\n' + err)
                                return
                            }
                        }

                        // remove the whole directory from the tmp dir
                        fs.remove(path.resolve(
                            tmpInstalationPath,
                            this.name)
                        )

                        if (callback) {
                            callback(this)
                        }

                        // update the information in the terminal
                        this.updateLine(false, colors.greenBright(''.padStart(18, '█')), 'Done')

                        // resolve with the package-lock installed dependencies (within installData)
                        resolve(this)
                    })
                    .catch(e => {
                        reject('Failed recovering information about the module ' + this.installed.installData.dep + ' just installed: ' + e)
                    })
                }
            })
        })
    }

    updateLine (full, ...data) {
        if (full) {
            tu.moveTo('position', {
                row: this.installData.pos.row + 1,
                col: this.installData.pos.col
            })
            let dep = this.installData.dep.split('@')
            // crtical some times takes about a minute to install
            if (dep[0] === 'critical') {
                dep[0]+= ' (may take a minute)'
            }
            
            process.stdout.write(
                colors.dim(''.padStart(18, '░')) + 
                ' | ' +
                colors.bold('Pkg: ') +
                colors.underline((dep[0].padEnd(40).substring(0, 40))) +
                colors.bold(' Vs: ') +
                colors.underline((dep[1] === '*' ? 'any      ': dep[1]))
            )
        } else {
            tu.moveTo('position', {
                row: this.installData.pos.row + 1,
                col: this.installData.pos.col
            })
        }

        process.stdout.write((data[0] || '') + '\n' + colors.dim((data[1] || '').substring(0, 60)) + '\x1b[K')
        tu.moveTo('position', {
            row: this.installData.startingRow + this.installData.concurrently * 2 + 2,
            col: 0
        })
    }
}



// WEBPACK FOOTER //
// ./src/installer.js